import config from 'config'
import React, { useEffect, useState } from 'react';
import './userDashboard.css'
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import Book from "LIBRARY/CommonResources/images/Book.png"
import Laptop from "LIBRARY/CommonResources/images/Laptop.png"
import membership from "LIBRARY/CommonResources/images/membership.png"
import papers from "LIBRARY/CommonResources/images/papers.png"
import people from "LIBRARY/CommonResources/images/people.png"
import link from "LIBRARY/CommonResources/images/link.png"
import pdfImg from "LIBRARY/CommonResources/images/pdfImg.png"
import sound from "LIBRARY/CommonResources/images/sound.png"
import video from "LIBRARY/CommonResources/images/video.png"
import LibraryApiCall from 'LibraryApiCall';
import { Base64 } from "js-base64";
import QRCode from "react-qr-code";
import Barcode from "react-barcode";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from "moment";
import { useSelector } from 'react-redux';
import studentLibraryEntryCount from "LIBRARY/CommonResources/images/studentLibraryEntryCount.png"
import facultyLibraryEntryCount from "LIBRARY/CommonResources/images/facultyLibraryEntryCount.png"

export const UserDashboard = () => {

    //required states 
    const [resourceCount, setResourceCount] = useState('');
    const [eResourceCount, setEResourceCount] = useState('');
    const [periodicalsCount, setPeriodicalsCount] = useState('');
    const [availableCount, setAvailableCount] = useState('');
    const [missingCount, setMissingCount] = useState('');
    const [donorCount, setDonorCount] = useState('');
    const [categoryCount, setCategoryCount] = useState('');
    const [pRCount, setPRCount] = useState('');
    const [requisitionCount, setRequisitionCount] = useState('');
    const [issuedCount, setIssuedCount] = useState('');
    const [returnedCount, setReturnedCount] = useState('');
    const [myIssuedCount, setMyIssuedCount] = useState('');
    const [issueReturnData, setIssueReturnData] = useState({});
    const [loadingIssueList, setLoadingIssueList] = useState(false);
    const [eResourceData, setEResourceData] = useState({});
    const [loadingEResourceList, setLoadingEResourceList] = useState(false);
    const [opacLink, setOpacLink] = useState(config.RootUrl + '/public/library/#/' + config.instituteUrl);
    const [showInstituteWiseOPAC, setShowInstituteWiseOPAC] = useState(false)

    const [linkedInstituteArray, setLinkedInstituteArray] = useState({})
    const [linkedIidArray, setLinkedIidArray] = useState([])

    const [studentLibraryCount, setStudentLibraryCount] = useState(0);
    const [facultyLibraryCount, setFacultyLibraryCount] = useState(0);

    const AdminAccessReducer = useSelector((state) => state.RouteMenuReducer);

    // 1️⃣ Fetch linked institute list for NON-faculty
    useEffect(() => {
        if (config.account !== "faculty") {
            GetAssignedInstituteList();
        }
    }, []);


    // 2️⃣ Main effect — runs when required data is available
    useEffect(() => {

        if (config.account === "faculty") {

            const iidList = AdminAccessReducer?.iidArray?.iidArray;
            const multiInst = AdminAccessReducer?.multipleInstituteDetails?.multipleInstituteDetails;

            // Run API calls only when iidArray is received
            if (iidList?.length > 0) {
                apiCallToDashboardCount();
                apiToGetMyIssuedResourceList();
                apiToGetLibraryEResources();
            }

            // Set OPAC link only when institute details are loaded
            if (multiInst && Object.keys(multiInst).length > 0) {
                const firstInst = Object.values(multiInst)[0];
                setOpacLink(config.RootUrl + '/public/library/#/' + firstInst.institute_url);
            }

        } else {

            // For Non-faculty — same behavior but using linked arrays
            if (linkedIidArray?.length > 0) {

                apiCallToDashboardCount();
                apiToGetMyIssuedResourceList();
                apiToGetLibraryEResources();

                if (Object.values(linkedInstituteArray)?.length > 0) {
                    const firstInst = Object.values(linkedInstituteArray)[0];
                    setOpacLink(config.RootUrl + '/public/library/#/' + firstInst.institute_url);
                }
            }
        }

    }, [
        AdminAccessReducer?.iidArray?.iidArray,
        AdminAccessReducer?.multipleInstituteDetails?.multipleInstituteDetails,
        linkedIidArray
    ]);

    // 3️⃣ Non-faculty API call
    const GetAssignedInstituteList = async () => {
        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_GetLinkedInstituteStatus',
            requestData,
            '/api/library/libraryLinkInstitute.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                GetAssignedInstituteList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                setLinkedInstituteArray(apiResult.linkedInstituteData || {});
                setLinkedIidArray(apiResult.linkedIidArray || []);
            }
        }
    };

    // useEffect(() => {        
    //     if (linkedIidArray?.length > 0) {
    //         apiCallToDashboardCount();
    //         apiToGetMyIssuedResourceList();
    //         apiToGetLibraryEResources();

    //         if (Object.values(linkedInstituteArray)?.length > 0) {
    //             setOpacLink(config.RootUrl + '/public/library/#/' + Object.values(linkedInstituteArray)[0].institute_url)
    //         }
    //     }
    // }, [linkedIidArray]);


    const apiCallToDashboardCount = async (pageNumber) => {
        // setLoadingStatus(true);

        let userId = '';
        let role = '';
        let iidArrayValue = [];

        if (config.account == "faculty") {
            userId = config.faculty_id;
            role = "teaching";
            iidArrayValue = AdminAccessReducer.iidArray.iidArray;
        } else if (config.account == "student") {
            userId = config.studentInfo.stuid;
            role = "student";
            iidArrayValue = linkedIidArray
        }

        let requestData = {
            "iid": config.institute_id,
            "facultyId": userId,
            "role": role,
            "iidArray": iidArrayValue,
        };
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getLibraryDashboardCount',
            requestData,
            '/api/library/instructor.php'
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToDashboardCount();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                setResourceCount(apiResult.resources_count)
                setEResourceCount(apiResult.e_resource_count);
                setPeriodicalsCount(apiResult.periodicals_count);
                setAvailableCount(apiResult.available_resources_count);
                setMissingCount(apiResult.other_resources_count);
                setCategoryCount(apiResult.resource_category_count);
                setRequisitionCount(apiResult.resource_requisition_count);
                setDonorCount(apiResult.donors_count);
                setStudentLibraryCount(apiResult.student_entry_count ?? 0);
                setFacultyLibraryCount(apiResult.faculty_entry_count ?? 0);
            }
        }
    }

    const apiToGetLibraryEResources = async (pageNumber) => {
        setLoadingEResourceList(true);

        let iidArrayValue = [];

        if (config.account == "faculty") {
            iidArrayValue = AdminAccessReducer.iidArray.iidArray;
        } else if (config.account == "student") {
            iidArrayValue = linkedIidArray
        }

        let requestData = {
            "instituteId": config.institute_id,
            "pageIndex": 1,
            "limit": 10,
            "iidArray": iidArrayValue,
        };
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_getEResources',
            requestData,
            '/api/library/library.php'
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiToGetLibraryEResources();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                setEResourceData(apiResult.data);
                setLoadingEResourceList(false);
            }
        }
    }

    const apiToGetMyIssuedResourceList = async (pageNumber) => {
        setLoadingIssueList(true);

        let userId = '';
        let role = '';
        let iidArrayValue = [];

        if (config.account == "faculty") {
            userId = config.faculty_id;
            role = "teaching";
            iidArrayValue = AdminAccessReducer.iidArray.iidArray;
        } else if (config.account == "student") {
            userId = config.studentInfo.stuid;
            role = "student";
            iidArrayValue = linkedIidArray
        }

        let requestData = {
            "iid": config.institute_id,
            "pageIndex": 1,
            "limitPerPage": 10,
            "userId": userId,
            "role": role,
            "iidArray": iidArrayValue,
        };
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetAllMyIssuedResourceList',
            requestData,
            '/api/library/instructor.php'
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiToGetMyIssuedResourceList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                setIssuedCount(apiResult.totalRecords);
                setIssueReturnData(apiResult.data);
                setLoadingIssueList(false);
            }
        }
    }

    const returnMultipleOpacLink = () => {

        const isFaculty = config.account === "faculty";

        // Decide institute source based on role
        const instituteSource = isFaculty
            ? AdminAccessReducer?.multipleInstituteDetails?.multipleInstituteDetails
            : linkedInstituteArray;

        // If no data, don't render anything
        if (!instituteSource || Object.keys(instituteSource).length === 0) {
            return null;
        }

        return (
            <div id="addAccessSideMenu" style={{ display: showInstituteWiseOPAC ? 'flex' : 'none' }}>
                <div id="addMemberDataContainer">
                    <div id="addAccessHeader" className="row">
                        <FontAwesomeIcon icon={['fas', 'times']} size="lg" color="#000" onClick={() => setShowInstituteWiseOPAC(false)} style={{ cursor: "pointer" }} />
                        <h5 style={{ paddingLeft: '30%' }} className="col-11">Institute Wise OPAC Access Link</h5>
                    </div>

                    <div className="table-responsive fixTableHead p-3" id='tableResponsive'>
                        <table className="table table-bordered  vm_libraryReport_table" id="resourceList">
                            <thead>
                                {/* Column headers */}
                                <tr>
                                    <th className='vm_custom_body4' style={{ padding: '5px 5px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Institute</th>
                                    <th className='vm_custom_body4' style={{ padding: '5px 5px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>Access OPAC URL</th>
                                    <th className='vm_custom_body4' style={{ padding: '5px 5px', backgroundColor: "#F5F8FA", border: '1.01px solid #E0E8EF' }}>QR Code</th>
                                </tr>
                            </thead>

                            <tbody>
                                {Object.keys(instituteSource).map((key, index) => {

                                    const instituteDetails = instituteSource[key];
                                    const opacLinkData =
                                        config.RootUrl +
                                        '/public/library/#/' +
                                        instituteDetails.institute_url;

                                    return (
                                        <tr key={index}>
                                            <td
                                                className="table-rows vm_custom_body5"
                                                style={{ border: '1.01px solid #E0E8EF' }}
                                            >
                                                <p>{instituteDetails.institute_short_code}</p>
                                            </td>

                                            <td
                                                className="table-rows vm_custom_body5"
                                                style={{ border: '1.01px solid #E0E8EF' }}
                                            >
                                                <a
                                                    href={opacLinkData}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="headings ui-link-hover"
                                                    style={{
                                                        fontWeight: 'bold',
                                                        color: '#007bff',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    <u>Access OPAC</u>
                                                </a>
                                            </td>

                                            <td
                                                className="table-rows vm_custom_body5"
                                                style={{ border: '1.01px solid #E0E8EF' }}
                                            >
                                                <QRCode value={opacLinkData} size={75} />
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <RoutingMenu activeScreen="userDashboard" />
            <div className='libraryUDashboard-container'>
                <div className='col-md-12 pl-0 pr-0 pb-5'>
                    <div className='row'>
                        <div className='col-md-8 pl-0 pr-0'>
                            <div className='welcomeRectangle'>
                                <div className='col-md-12'>
                                    <div className='row'>
                                        <div className='col-md-8'>
                                            <p className='fontType' style={{ fontSize: '28px', fontWeight: 'bold' }}>Hello, {config.instructorInfo.FirstName} !</p>
                                            <p className='fontType mt-2' style={{ fontSize: '17px' }}>Welcome back to your library. It is great to see you once again.</p>
                                        </div>
                                        <div className='col-md-4'>
                                            <img className='peopleImg' src={people} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='countCardsDisplay mt-3'>
                                <div className='countRectangles mr-3' >
                                    <div className='p-3'>
                                        <div className='d-flex justify-content-between'>
                                            <span className='imgRound'><div className='d-flex flex-column align-items-center pt-2'><img className='countImgs' src={Book} /></div></span>
                                            <span className='mt-2'>
                                                <FontAwesomeIcon icon={['fas', 'chevron-circle-right']} size="xl" color='#295ADE' style={{ fontSize: '22px', cursor: 'pointer' }} onClick={() => window.location.href = config.RootUrl + '/modules/library/#/user/resource/' + Base64.encode("All")} />
                                            </span>
                                        </div>
                                        <div className='mt-4'>
                                            <p className='count'>{resourceCount}</p>
                                            <p className='userSmallHeadings mt-2'>Resources</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='countRectangles mr-3 marginTopForMobView'>
                                    <div className='p-3'>
                                        <div className='d-flex justify-content-between'>
                                            <span className='imgRound'><div className='d-flex flex-column align-items-center pt-2'><img className='countImgs' src={Laptop} /></div></span>
                                            <span className='mt-2'>
                                                <FontAwesomeIcon icon={['fas', 'chevron-circle-right']} size="xl" color='#295ADE' style={{ fontSize: '22px', cursor: 'pointer' }} onClick={() => window.location.href = config.RootUrl + '/modules/library/#/user/eresoures'} />
                                            </span>
                                        </div>
                                        <div className='mt-4'>
                                            <p className='count'>{eResourceCount}</p>
                                            <p className='userSmallHeadings mt-2'>E-Resources</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='countRectangles mr-3 marginTopForMobView'>
                                    <div className='p-3'>
                                        <div className='d-flex justify-content-between'>
                                            <span className='imgRound'><div className='d-flex flex-column align-items-center pt-2'><img className='countImgs' src={papers} /></div></span>
                                            <span className='mt-2'>
                                                <FontAwesomeIcon icon={['fas', 'chevron-circle-right']} size="xl" color='#295ADE' style={{ fontSize: '22px', cursor: 'pointer' }} onClick={() => window.location.href = config.RootUrl + '/modules/library/#/user/periodicals'} />
                                            </span>
                                        </div>
                                        <div className='mt-4'>
                                            <p className='count'>{periodicalsCount}</p>
                                            <p className='userSmallHeadings mt-2'>Periodicals/ Journal</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='libraryCards marginTopForMobView'>
                                    <div className='p-3'>
                                        <p className='fontType' style={{ fontSize: '16px', color: '#ffffff' }}>My Library Card</p>
                                        <div className='d-flex flex-column align-items-center mt-1 mb-1'>
                                            <Barcode
                                                value={config.instructorInfo.user_id}
                                                width={'1'}
                                                height={'25%'}
                                                background={'transparent'}
                                                lineColor={'#ffffff'}
                                                displayValue={false}
                                            />
                                            <p className="mt-1 mb-1 fontType" style={{ fontSize: '14px', fontWeight: '600', color: '#ffffff' }}>{config.instructorInfo.FirstName + '  ' + config.instructorInfo.LastName}</p>
                                            <p className="mt-1 mb-1 fontType" style={{ fontSize: '14px', fontWeight: '600', color: '#D4D4D4' }}>{config.instructorInfo.user_id}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='issuedRectangle mt-3'>
                                <div className='p-3'>
                                    <div className='d-flex justify-content-between'>
                                        <span className='userHeadings' style={{ fontSize: '18px', fontWeight: '500' }} >My Issued Resources <span style={{ fontSize: '14px', fontWeight: '500' }}>({issuedCount})</span></span>
                                        <a onClick={() => window.location.href = config.RootUrl + '/modules/library/#/user/issuedresources'} className='fontType' style={{ fontSize: '12px', color: '#295ADE', fontWeight: '500' }}><u>View All</u></a>
                                    </div>
                                    <div className='mt-3 table-responsive' style={{ height: '355px', overflowY: 'auto' }}>
                                        <table class="table table-hover table-borderless">
                                            <thead style={{ backgroundColor: "#ffffff", position: 'sticky', top: '-1%' }}>
                                                <tr>
                                                    <th scope="col">Institute</th>
                                                    <th scope="col">Title</th>
                                                    <th scope="col">Issued On</th>
                                                    <th scope="col">Due On</th>
                                                    <th scope="col">Return On</th>
                                                    {/* <th scope="col">Renew On</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {loadingIssueList ?
                                                    <div className="mt-3 d-flex justify-content-center align-items-center">
                                                        <ButtonLoader />
                                                    </div>
                                                    :
                                                    Object.keys(issueReturnData).length > 0 ?
                                                        Object.keys(issueReturnData).reverse().map((items, index) => {
                                                            let resourceData = issueReturnData[items];

                                                            return (
                                                                <>
                                                                    <tr>
                                                                        <td style={{ padding: '9px' }}>{resourceData.resourseInstituteName || ''}</td>
                                                                        <td style={{ padding: '9px' }}>{resourceData.title}</td>
                                                                        <td style={{ padding: '9px' }}>{moment(resourceData.issued_date).format('DD MMM YYYY')}</td>
                                                                        <td style={{ padding: '9px' }}>{resourceData.dueDate}</td>
                                                                        <td style={{ padding: '9px' }}>{resourceData.return_date !== '0000-00-00' ? moment(resourceData.return_date).format('DD MMM YYYY') : '-'}</td>
                                                                        {/* <td>{resourceData.title}</td> */}
                                                                    </tr>
                                                                </>
                                                            )
                                                        })
                                                        :
                                                        <tr>
                                                            <td style={{ padding: 10 }} colSpan={4}>No resource issued yet.</td>
                                                        </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-3" style={{ Width: "100% !important" }}>
                                <img className='membershipImg' src={membership} />
                            </div>
                        </div>
                        <div className='col-md-4 eRectangle marginTopForMobView'>
                            {/* Student Faculty Library Entry Count */}
                            <div className="library-summary-wrapper">
                                <div className="library-summary-container">
                                    {/* Student Library Entry */}
                                    <div className="library-card">
                                        <div className="library-card-icon">
                                            <img src={studentLibraryEntryCount} alt="StudentLibraryEntry" />
                                        </div>
                                        <div className="library-card-content">
                                            <p className="library-title">Student Library Entry</p>
                                            <p className="library-count">
                                                {studentLibraryCount}
                                            </p>
                                        </div>
                                    </div>

                                    {/* Faculty Library Entry */}
                                    <div className="library-card">
                                        <div className="library-card-icon">
                                            <img src={facultyLibraryEntryCount} alt="FacultyLibraryEntry" />
                                        </div>
                                        <div className="library-card-content">
                                            <p className="library-title">Faculty Library Entry</p>
                                            <p className="library-count">
                                                {facultyLibraryCount}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="opac-rectangle pr-2 marginTopForMobView">
                                <div class="col-md-12 d-flex">
                                    <div className="col-md-9 mt-4">
                                        <p style={{ fontWeight: 'bold' }}>OPAC</p>
                                        <p className="headings mt-3 mb-3" style={{ color: '#555555' }}>An OPAC (Online Public Access Catalog) is an online bibliography of a library collection that is available to the public.</p>
                                        {/* <a href={opacLink} target="_blank" className="headings ui-link-hover" style={{ fontWeight: 'bold' }}><u>Access OPAC</u></a> */}
                                        <a onClick={() => { setShowInstituteWiseOPAC(true) }} className="headings ui-link-hover" style={{ fontWeight: 'bold', color: '#007bff', cursor: 'pointer' }}><u>Access Multiple OPAC</u></a>
                                    </div>
                                    <div className="col-md-3 mt-5 QRPadding">
                                        <QRCode
                                            value={opacLink}
                                            size={75}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='eResourceRectangle mt-3'>
                                <div className='p-3'>
                                    <p className='fontType' style={{ fontSize: '18px', fontWeight: '500' }}>E-Resources <span style={{ fontSize: '14px', fontWeight: '500' }}>({eResourceCount})</span>
                                        <a onClick={() => window.location.href = config.RootUrl + '/modules/library/#/user/eresoures'} className='fontType mt-4' style={{ fontSize: '12px', color: '#295ADE', fontWeight: '500', float: 'right' }}><u>View All</u></a>
                                    </p>
                                    <p className='fontType' style={{ fontSize: '13px', color: '#616161' }}>This section you can view the videos, images, doc, pdf etc.</p>

                                    <div className="mt-3" style={{ height: '610px', overflowY: 'auto' }}>
                                        {loadingIssueList ? (
                                            <div className="mt-4 d-flex justify-content-center align-items-center">
                                                <ButtonLoader />
                                            </div>
                                        ) : (
                                            Object.keys(eResourceData).length > 0 &&
                                            Object.keys(eResourceData).reverse().map((items, index) => {
                                                let eResource = eResourceData[items];
                                                let resourceImg;

                                                switch (eResource.resourceType) {
                                                    case "PDF":
                                                        resourceImg = pdfImg;
                                                        break;
                                                    case "URL":
                                                        resourceImg = link;
                                                        break;
                                                    case "Audio":
                                                        resourceImg = sound;
                                                        break;
                                                    default:
                                                        resourceImg = video;
                                                }

                                                return (
                                                    <div className='col-md-12 mt-4 pl-0' key={index}>
                                                        {eResource.resourceType === 'Video' && index === 0 ? (
                                                            <>
                                                                <div className='row'>
                                                                    <div className='col-md-12 pl-0'>
                                                                        <div className='eResourceVideo'>
                                                                            {eResource.resourceThumbnail != '' && eResource.resourceThumbnail != undefined ?
                                                                                (
                                                                                    <div className='d-flex flex-column align-items-center'>

                                                                                        <img
                                                                                            // style={{ height: "55%", width: "70%" }}
                                                                                            className="eResource-image"
                                                                                            resizeMode='contain'
                                                                                            src={eResource.resourceThumbnail}
                                                                                        />
                                                                                    </div>
                                                                                ) :
                                                                                (
                                                                                    <div className='d-flex flex-column align-items-center pt-3 '>
                                                                                        <img
                                                                                            style={{ height: "25%", width: "25%" }}
                                                                                            resizeMode='contain'
                                                                                            src={resourceImg}
                                                                                        />
                                                                                    </div>
                                                                                )
                                                                            }

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='row'>
                                                                    <div className='col-md-12 mt-3'>
                                                                        <p className='fontType' style={{ fontSize: '16px' }}>{eResource.resourceTitle}</p>
                                                                        <p className='fontType' style={{ fontSize: '13px', color: '#444444', float: 'right' }}>- By {eResource.resourceAuthor}</p>
                                                                    </div>
                                                                </div>
                                                                <div className='d-flex justify-content-between'>
                                                                    <p className='fontType mt-3' style={{ fontSize: '16px', fontWeight: '700' }}>List of e-resources</p>
                                                                    {/* <a  onClick={() => window.location.href = config.RootUrl + '/modules/library/#/user/eresoures'} className='fontType mt-4' style={{ fontSize: '12px', color: '#295ADE', fontWeight:'500' }}><u>View All</u></a> */}
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <div className='row'>
                                                                <div className='col-md-4 pl-0'>
                                                                    <div className='eResource'>
                                                                        {eResource.resourceThumbnail != '' && eResource.resourceThumbnail != undefined ?
                                                                            (
                                                                                <div className='d-flex flex-column align-items-center'>
                                                                                    <img
                                                                                        // style={{ height: "55%", width: "70%" }}
                                                                                        className="eResource-image"
                                                                                        resizeMode='contain'
                                                                                        src={eResource.resourceThumbnail}
                                                                                    />
                                                                                </div>
                                                                            ) :
                                                                            (
                                                                                <div className='d-flex flex-column align-items-center pt-4 '>
                                                                                    <img
                                                                                        style={{ height: "25%", width: "25%" }}
                                                                                        resizeMode='contain'
                                                                                        src={resourceImg}
                                                                                    />
                                                                                </div>
                                                                            )
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className='col-md-8 mt-3'>
                                                                    <p className='fontType' style={{ fontSize: '16px' }} title={eResource.resourceTitle}>{eResource.resourceTitle.length > 70 ? eResource.resourceTitle.substring(0, 70) + '...' : eResource.resourceTitle} | {eResource.eResourceInstituteName}</p>
                                                                    <p className='fontType' style={{ fontSize: '13px', color: '#444444' }}>- By {eResource.resourceAuthor}</p>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })
                                        )}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {showInstituteWiseOPAC && returnMultipleOpacLink()}
        </>
    )

}
